<div class="sidenav">
  @for (r of routes(); track $index) {
    <div class="sidenav-route">
      <a class="sidenav-route-link" routerLinkActive="mod-active" routerLink="/app/{{ parentRoute() }}/{{ r.route }}">
        <mat-icon svgIcon="{{ r.icon }}" class="sidenav-route-link-icon"></mat-icon>
        {{ r.translationKey | translate }}
      </a>
      @if (r.children) {
        <div class="sidenav-route-children">
          @for (child of r.children; track $index) {
            <a class="sidenav-route-children-link" routerLinkActive="mod-active" routerLink="/app/{{ parentRoute() }}/{{ r.route }}/{{ child.route }}">
              {{ child.translationKey | translate }}
            </a>
          }
        </div>
      }
    </div>
  }
</div>
